import apiReq from '../commontools/api.js'
export function GetOrderGroupData(OrderID) {
	var url='/OrderGroup/GetOrderGroupData/'+OrderID;
	return apiReq.get(url)
}
export function GetOrderGroupByGroupID(OrderID,GroupID) {
	var url='/OrderGroup/GetOrderGroupByGroupID/'+OrderID+'/'+GroupID;
	return apiReq.get(url)
}

export function AddGroup(info){
	var url='/OrderGroup/AddGroup';
	var p = {
		data: info
	}
	return apiReq.post(url, p);
}
export function EditGroup(info){
	var url='/OrderGroup/EditGroup';
	var p = {
		data: info
	}
	return apiReq.post(url, p);
}
export function DelGroup(OrderID,groupID) {
	var url='/OrderGroup/DelGroup/'+OrderID+'/'+groupID;
	return apiReq.get(url)
}
export default{
	GetOrderGroupData,
	GetOrderGroupByGroupID,
	AddGroup,
	EditGroup,
	DelGroup
}